export const MAX_HIGHLIGHT_PRODUCT = 2;
